<div class="donations">
    <div class="sparks">
      <i class="fas fa-hand-holding-heart"></i>
    </div>
    <a [routerLink]="['/faire-un-don']" >
      FAITES UN DON
      <span>DON SÉCURISÉ</span>
    </a>
</div>